function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { Row, Container, Col, Table } from 'react-bootstrap';
import { Statistic, Divider, Skeleton, Form, Button, DatePicker, Space, Drawer, Alert } from 'antd';
import Common from "../components/includes/Common";
import CustomerTable from '../components/CustomerTable';
import { WalletFill, Cash, CreditCardFill, PersonFill, HouseFill } from 'react-bootstrap-icons';
import ValidationSheet from "../components/ValidationSheet";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Reports = function Reports() {
  var ref = useRef();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    customers = _useState2[0],
    setCustomers = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    monthCustomers = _useState4[0],
    setMonthCustomers = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDayDataLoading = _useState6[0],
    setIsDayDataLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isMonthDataLoading = _useState8[0],
    setIsMonthDataLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataDraweVisible = _useState10[0],
    setIsDataDrawerVisible = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    searchCustomers = _useState12[0],
    setSearchCustomers = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSearchDataLoading = _useState14[0],
    setIsSearchDataLoading = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    searchResponseMessage = _useState16[0],
    setSearchResponseMessage = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    agentsSales = _useState18[0],
    setAgentsSales = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isSheetDisplayed = _useState20[0],
    setIsSheetDisplayed = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    selectedCustomer = _useState22[0],
    setSelectedCustomer = _useState22[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var onSearchFinish = function onSearchFinish(values) {
    setSearchCustomers([]);
    setIsDataDrawerVisible(true);
    setIsSearchDataLoading(true);
    setSearchResponseMessage('');
    axios.post(Common.baseApiUrl + 'searchcustomersdata/' + Common.currentUser.id, {
      from: values.moment[0]._d,
      to: values.moment[1]._d
    }).then(function (response) {
      setIsSearchDataLoading(false);
      if (response.data.status == 200) {
        setSearchCustomers(response.data.customers);
      } else {
        setSearchResponseMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsSearchDataLoading(false);
      setSearchResponseMessage('Une erreur est survenue');
    });
  };
  var handleSheetDisplay = function handleSheetDisplay(c) {
    setSelectedCustomer(c);
    setIsSheetDisplayed(true);
  };
  useEffect(function () {
    setIsDayDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsDayDataLoading(false);
      if (response.data.status == 200) setCustomers(response.data.customers);
    })["catch"](function (error) {
      setIsDayDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getcurrentmonthcustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsMonthDataLoading(false);
      if (response.data.status == 200) setMonthCustomers(response.data.customers);
    })["catch"](function (error) {
      setIsMonthDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getcustomersbyagent/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setAgentsSales(response.data.agentcustomers);
      }
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Drawer, {
      title: "Donn\xE9es",
      visible: isDataDraweVisible,
      onClose: function onClose() {
        setIsDataDrawerVisible(false);
      },
      width: "95%",
      destroyOnClose: false,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "cool-radius",
        children: [isSearchDataLoading && /*#__PURE__*/_jsx(Skeleton, {
          active: true
        }), searchResponseMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: searchResponseMessage
        }), /*#__PURE__*/_jsx("br", {}), searchCustomers.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              sm: 6,
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total clients",
                    value: searchCustomers.length.toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(PersonFill, {})
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Encaissement",
                    suffix: "GNF",
                    value: (searchCustomers.length * 200000).toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(Cash, {})
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              sm: 6
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(CustomerTable, {
            customers: searchCustomers,
            sheetDisplayHandler: handleSheetDisplay,
            table: "stable"
          })]
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        title: "Donn\xE9es",
        visible: isSheetDisplayed,
        onClose: function onClose() {
          setIsSheetDisplayed(false);
        },
        width: "80%",
        destroyOnClose: false,
        children: /*#__PURE__*/_jsx(ValidationSheet, {
          ref: ref,
          customer: selectedCustomer
        })
      })]
    }), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsx(Form, {
              layout: "horizontal",
              onFinish: onSearchFinish,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "moment",
                  rules: [{
                    required: true,
                    message: 'Veuillez choisir une période'
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    showTime: true
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  rules: [{
                    required: true,
                    message: 'send'
                  }],
                  children: /*#__PURE__*/_jsx(Button, {
                    htmlType: "submit",
                    type: "primary",
                    children: "Chercher"
                  })
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "RAPPORTS PAR CAISSIERE"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Table, {
              responsive: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Pr\xE9nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Login"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u CASH"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u TPE"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u OM"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Total Re\xE7u"
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: agentsSales.map(function (a) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: a.firstname
                    }), /*#__PURE__*/_jsx("td", {
                      children: a.lastname
                    }), /*#__PURE__*/_jsx("td", {
                      children: a.mobile.slice(3)
                    }), /*#__PURE__*/_jsx("td", {
                      children: (a.customers.length * 200000).toLocaleString('Fr')
                    })]
                  }, a.id);
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "JOURNEE EN COURS"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx(Divider, {}), !isDayDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total clients",
                    value: customers.length.toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(PersonFill, {})
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Encaissements",
                    suffix: "GNF",
                    value: (customers.length * 200000).toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(Cash, {})
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "MOIS EN COURS"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Ce mois ' + (today.getMonth() + 1) + '/' + today.getFullYear()
            }), /*#__PURE__*/_jsx(Divider, {}), !isMonthDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total clients",
                    value: monthCustomers.length.toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(PersonFill, {})
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Encaissements",
                    suffix: "GNF",
                    value: (monthCustomers.length * 200000).toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(Cash, {})
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "LISTE CLIENTS JOURNEE EN COURS"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), !isDayDataLoading ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {})]
    })]
  });
};
export default Reports;